import { Icon } from "@chakra-ui/react"
import { MdError, MdPriorityHigh } from "react-icons/md"

export const ErrorIcon = ({ ...rest }) => <Icon as={MdError} {...rest} />
export const ErrorAlertIcon = ({ ...rest }) => (
  <Icon as={MdPriorityHigh} {...rest} />
)
